import React from "react";
import "./DetailSearch.css";

const SearchFieldRow = ({
  label,
  name,
  value,
  onChange,
  condition,
  onConditionChange,
  isFuzzy,
  onFuzzyChange,
}) => {
  return (
    <div className="search-field-row">
        <label className="search-field-label">{label}</label>

        <input
            type="text"
            name={name}
            value={value}
            onChange={onChange}
            className="search-field-input"
        />

        <select
            name={`${name}_condition`}
            value={condition}
            onChange={onConditionChange}
            className="search-field-select"
        >
            <option value="0">を含む</option>
            <option value="1">で始まる</option>
            <option value="2">と等しい</option>
            <option value="3">で終わる</option>
        </select>

        <div className="search-field-fuzzy">
            <input
                type="checkbox"
                checked={isFuzzy}
                style={{width: '20px', height: '30px'}}
                onChange={(e) => {
                  onFuzzyChange(e.target.checked);
                }}
            />
            あいまい
        </div>
    </div>
  );
};

export default SearchFieldRow;
